import { orderBy } from 'lodash';
import moment from 'utils/moment';
import API from 'services/API';

export function getUnexplainedPaymentsList(id) {
  return API.request({
    method: 'GET',
    url: id
      ? `/payments/unexplained/getUnexplainedPayment?id=${id}`
      : '/payments/unexplained/getUnexplainedPayments',
    mapper: (data) => {
      const unexplainedPaymentsList = (id ? [data] : data).map((item) => {
        const { notificationDate, documentDate } = item;
        return Object.assign({}, item, {
          fixable: isFixable(item),
          notificationDate: notificationDate ? moment.fromServerDatetime(notificationDate) : null,
          documentDate: documentDate ? moment.fromServerDatetime(documentDate) : null,
        });
      });
      return orderBy(
        unexplainedPaymentsList,
        ['documentDate', 'documentNumber', 'sumDoc'],
        ['desc', 'desc', 'desc'],
      );
    },
  });
}

function isFixable(payment) {
  return !payment.processed && payment.actual;
}

export function setUnexplainedPaymentProccessed({ id, paymentType }) {
  return API.request({
    method: 'POST',
    url: `/payments/unexplained/processed?id=${id}&paymentType=${paymentType}`,
  });
}

export function hasUnexplainedPayments() {
  return API.request({
    method: 'GET',
    url: '/payments/unexplained/hasUnexplainedPayments',
  });
}
